"use client";

import Breadcrumb from "@/components/Breadcrumb/Breadcrumb";
import AnchorLink from "@/components/ui/AnchorLink/AnchorLink";
import Icon from "@/components/ui/Icon/Icon";
import useMarginSticky from "@/hooks/useMarginSticky";
import { IBackNavigation } from "@/types";

function BackNavigation(props: IBackNavigation) {
  const { crumbs } = props;
  const { margin } = useMarginSticky({
    component: '[id="header-desktop"]',
  });
  const share = async (shareData: any) => {
    try {
      await navigator.share(shareData);
    } catch (err) {
      console.log("error");
    }
  };

  return (
    <div
      className={`
                z-10
                px-m
                md:container
            `}
      style={{ paddingTop: margin !== 0 ? `${margin + 24}px` : `48px` }}
    >
      <div
        className={`
                    flex
                    items-center	   
                    justify-between
                `}
      >
        {/* @TODO: comment because this break releases */}
        {/* <Breadcrumb entry={crumbs} /> */}

        <span
          className={`
                    font-primary
                    font-normal	
                    text-[#FFFFFF]
                    text-[12px]
                    cursor-pointer	
                    `}
          onClick={() => share({ title: "share btn", text: "share btn", url: window.location.href })}
        >
          <Icon name="share.svg" size="24" className="stroke-white" />
        </span>
      </div>
    </div>
  );
}

export default BackNavigation;
